import React from 'react';
import './style.less';
import Modal from '@homeaway/react-modal';

export const SearchBox = ({opened, onClose, children, expandedSearchBox, consolidatedSearchBox, smartDatePicker, title = 'Search'}) => (
    <div className={`search__box-container${smartDatePicker && ' smart-datepicker' || ''}`}>
        <Modal
            id="modal-container"
            className="modal-container"
            isOpen={opened}
            onClose={onClose}
            title={title}
        >
            <div className="search__box">
                {children}
            </div>
        </Modal>

        <div className={`context${expandedSearchBox ? ' context--xs-show' : ''}`}>
            <div className={`search__box${consolidatedSearchBox ? ' consolidated-searchbox' : ''}`}>
                {children}
            </div>
        </div>
    </div>

);
